import { CurrencyPipe } from '@angular/common';
import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IconComponent } from '@zero/shared/ui-web-design-system';
import { StatisticsFacade } from '@zero/statistics/domain';
import { MyChartBase } from '@zero/statistics/feature-statistics/base';
import { MyExpandedChartModalComponent } from './my-expanded-chart-modal/my-expanded-chart-modal.component';

@Component({
  selector: 'statistics-my-chart',
  templateUrl: './my-chart.component.html',
  styleUrls: ['./my-chart.component.scss'],
  imports: [TranslocoPipe, CurrencyPipe, IconComponent],
})
export class MyChartComponent extends MyChartBase {
  readonly #modal = inject(NgbModal);
  readonly #statisticsFacade = inject(StatisticsFacade);
  readonly #destroyRef = inject(DestroyRef);

  public openModal = async (): Promise<void> => {
    const modalRef = this.#modal.open(MyExpandedChartModalComponent, { size: 'fullscreen' });
    modalRef.componentInstance.model = this.model;
    modalRef.componentInstance.chartWithCash = this.chartWithCash;
    modalRef.componentInstance.chartWithoutCash = this.chartWithoutCash;

    this.#statisticsFacade.myChartWithoutCash$.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe((chart) => {
      modalRef.componentInstance.chartWithoutCash = chart;
    });

    this.#statisticsFacade.myChartWithCash$.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe((chart) => {
      modalRef.componentInstance.chartWithCash = chart;
    });

    try {
      await modalRef.result;
    } catch (e) {
      modalRef?.dismiss();
    } finally {
      this.reset();
    }
  };
}
